import { render } from "./HelpMenuButton.vue?vue&type=template&id=07087727"
import script from "./HelpMenuButton.vue?vue&type=script&lang=js"
export * from "./HelpMenuButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__